import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantRestoreMutation } from "@/v2-backoffice-client/tenant/restore/tenant.restore.mutation"

export type TenantRestoreButtonProps = Omit<ConfirmButtonProps, "onConfirm"> & {
  tenantId: number | null | undefined
  onCompleted?(): void
}

function TenantRestoreButton(props: TenantRestoreButtonProps) {
  const { tenantId, confirmContent, onCompleted, ...confirmButtonProps } = props

  const [restoreTenant, { loading, error }] = useTenantRestoreMutation({
    onCompleted,
  })

  errorToast(error, {
    title: "Failed to restore team",
  })

  if (!tenantId) return null

  return (
    <ConfirmButton
      id="tenant-restore-button"
      variant="success"
      confirmVariant="success"
      size="tiny"
      iconSrc="undo-alt"
      content="Restore team"
      confirmContent={
        confirmContent ?? "Are you sure you want to restore this team?"
      }
      isLoading={loading}
      onConfirm={() => {
        restoreTenant({ variables: { id: tenantId } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default TenantRestoreButton
